import { ProductStoresScreen } from '../features/catalog/ProductStoresScreen'

export function ProductStoresPage() {
  return <ProductStoresScreen />
}
